import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTour } from '../../context/TourContext';
import { getTopic, featureHasTour } from '../../help/registry';
import Icon from '../Icon';
import './HelpModal.css';

/**
 * NER-1276 — full help content shown from the Help Center.
 *
 * Reuses the shared modal classes from App.css (.modal-overlay / .modal-content
 * / .modal-header / .modal-body / .modal-actions) — does NOT redefine them.
 */
function HelpModal({ topicKey, onClose }) {
  const { t } = useTranslation();
  const { startTour } = useTour();

  const topic = getTopic(topicKey);
  if (!topic) return null;

  const showTour = featureHasTour(topic.feature);

  const handleStartTour = () => {
    onClose();
    startTour(topic.feature);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{t(topic.titleKey)}</h2>
          <button
            type="button"
            className="btn btn-ghost btn-sm"
            onClick={onClose}
            aria-label={t('common.close')}
          >
            <Icon name="close" size="small" />
          </button>
        </div>

        <div className="modal-body">
          <p className="help-modal-description">{t(topic.descriptionKey)}</p>
        </div>

        <div className="modal-actions">
          <button type="button" className="btn btn-ghost" onClick={onClose}>
            {t('common.close')}
          </button>
          {showTour && (
            <button type="button" className="btn btn-primary" onClick={handleStartTour}>
              <Icon name="play_circle_outline" size="small" />
              {t('help.startTour')}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default HelpModal;
